import getAuditTrailParahubSummary from '@hooks/parahub/getAuditTrailParahubSummary';

const useGetAuditTrailParahubSummary = () => {
    return getAuditTrailParahubSummary();
};

export default useGetAuditTrailParahubSummary;
